import { AritoIcon, FormFieldV2 } from '@/components/custom/erp';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { ExcelSheetTabProps } from './types';

const ExcelSheetTab = ({ sheetOptions = [], isLoading = false, onSheetChange, onRefresh }: ExcelSheetTabProps) => {
  const hasFile = sheetOptions.length > 0;

  return (
    <div className='p-4'>
      <div className='flex items-center'>
        <Label className='w-[115px]'>Sheet</Label>
        <FormFieldV2
          name='sheetIndex'
          type='select'
          className='w-[390px]'
          options={sheetOptions}
          onValueChange={onSheetChange}
          disabled={isLoading || !hasFile}
          placeholder={isLoading ? 'Đang tải...' : hasFile ? 'Chọn sheet' : 'Chưa có file được chọn'}
        />
        <Button
          type='button'
          variant='outline'
          size='sm'
          className='ml-2'
          onClick={onRefresh}
          disabled={isLoading || !hasFile}
        >
          <AritoIcon icon={15} />
        </Button>
      </div>
    </div>
  );
};

export default ExcelSheetTab;
